import { useRef } from 'react'
import clamp from 'lodash-es/clamp'

import { bindDrag, getHuePointerPosition } from '../ColorPickerPopover.utils'

import * as styles from './ColorPickerPopoverHueSlider.module.css'

function ColorPickerPopoverHueSlider({ hue, onChange }) {
  const sliderRef = useRef(null)

  function updateHue(clientX) {
    if (!sliderRef.current) {
      return
    }

    const rect = sliderRef.current.getBoundingClientRect()
    const x = clamp(clientX - rect.left, 0, rect.width)

    onChange((x / rect.width) * 360)
  }

  function handleMouseDown(event) {
    updateHue(event.clientX)

    bindDrag(moveEvent => {
      updateHue(moveEvent.clientX)
    })
  }

  return (
    <div className={styles.slider}>
      <div
        className={styles.sliderWrapper}
        ref={sliderRef}
        onMouseDown={handleMouseDown}
      >
        <div className={styles.pointer} style={getHuePointerPosition(hue)}>
          <div />
        </div>
      </div>
    </div>
  )
}

export default ColorPickerPopoverHueSlider
